import { Application, Container, Graphics, Text } from 'pixi.js';
import type { Locale } from '@holdline/content';
import { BLEED, COLORS, L } from './layout';

const LANG_KEY = 'holdline.lang';

/** The language the player chose earlier on this device, or null. */
export function storedLocale(): Locale | null {
  try {
    const v = localStorage.getItem(LANG_KEY);
    return v === 'ru' || v === 'en' ? v : null;
  } catch {
    return null;
  }
}

export function storeLocale(l: Locale): void {
  try {
    localStorage.setItem(LANG_KEY, l);
  } catch {
    /* private mode */
  }
}

/**
 * First-launch language screen, shown before anything else so the tutorial comes in the right language.
 * Labels are written in their own language on purpose; `suggested` (from Telegram) is drawn highlighted.
 */
export function pickLanguage(app: Application, stageRoot: Container, suggested: Locale): Promise<Locale> {
  return new Promise((resolve) => {
    const layer = new Container();
    layer.addChild(new Graphics().rect(-BLEED, -BLEED, L.W + BLEED * 2, L.H + BLEED * 2).fill(0x0f1115));
    const title = new Text({ text: 'Язык · Language', style: { fill: COLORS.text, fontSize: 22, fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif', fontWeight: 'bold' } });
    title.anchor.set(0.5);
    title.x = L.W / 2;
    title.y = 230;
    layer.addChild(title);
    const options: { id: Locale; label: string; sub: string }[] = [
      { id: 'ru', label: '🇷🇺  Русский', sub: 'Играть на русском' },
      { id: 'en', label: '🇬🇧  English', sub: 'Play in English' },
    ];
    options.forEach((o, i) => {
      const w = L.W - 72;
      const h = 72;
      const c = new Container();
      c.x = 36;
      c.y = 290 + i * (h + 18);
      const isSuggested = o.id === suggested;
      c.addChild(new Graphics().roundRect(0, 0, w, h, 16).fill(isSuggested ? COLORS.button : 0x232833).stroke({ width: 2, color: isSuggested ? COLORS.gold : COLORS.panelLine }));
      const lb = new Text({ text: o.label, style: { fill: COLORS.text, fontSize: 20, fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif', fontWeight: 'bold' } });
      lb.x = 20;
      lb.y = 14;
      const sb = new Text({ text: o.sub, style: { fill: isSuggested ? 0xdbe7ff : COLORS.textDim, fontSize: 12, fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif' } });
      sb.x = 20;
      sb.y = 44;
      c.addChild(lb, sb);
      c.eventMode = 'static';
      c.cursor = 'pointer';
      c.on('pointertap', () => {
        storeLocale(o.id);
        stageRoot.removeChild(layer);
        layer.destroy({ children: true });
        resolve(o.id);
      });
      layer.addChild(c);
    });
    const hint = new Text({ text: 'Можно сменить в меню · You can change it in the menu', style: { fill: COLORS.textDim, fontSize: 11, fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif' } });
    hint.anchor.set(0.5);
    hint.x = L.W / 2;
    hint.y = 490;
    layer.addChild(hint);
    stageRoot.addChild(layer);
    app.render();
  });
}
